export const ALERTS_ROUTES = {
    Alerts: 'Alerts',
    Explore: 'explore'
};
